import React from "react";
import * as styles from "./EuropeBadge.module.scss";

function EuropeBadge() {
  return (
    <div className={styles.root}>
      <span>
        <img src="https://images-temp.fibery.io/website-static/blog/common/flag-eu.webp" alt="EU flag"/>
      </span>
      <span>Crafted in Europe</span>
    </div>
  );
}

export default EuropeBadge;
